
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gbx/one-click",
      function () {
        return require("private-next-pages/gbx/one-click.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gbx/one-click"])
      });
    }
  